<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Ítems</h3>
            </div>
        </div>
        <div style="max-height: 300px" class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>Cod. Barra</th>
                        <th>Ítem</th>
                        <th>Cantidad</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                        <td>
                            {{ item.codigo_barra }}
                        </td>
                        <td>
                            {{ item.nombre_item }}
                        </td>
                        <td>
                            {{ item.cantidad }}
                        </td>
                    </tr>
                    <tr v-show="items.length === 0">
                        <td colspan="3">
                            <strong>No se ha encontrado ítems.</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="modal-buttons">
            <button type="button" @click="aceptar" class="btn-success"><i class="fa fa-check"></i><span>Aceptar</span></button>
            <button @click="cancelar" class="btn-danger btn--text"><i class="fa fa-ban"></i><span>Cancelar</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        }
    },
    methods: {
        aceptar: function () {
            this.$emit('aceptar', this.items);
        },
        cancelar: function () {
            this.$emit('cancelar');
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/AceptarItemsAdicionales.vue